import React from 'react'
import {AiOutlineAntDesign , AiOutlineCloudServer} from 'react-icons/ai'
import {VscCode} from 'react-icons/vsc'
import { useTranslation } from 'react-i18next';

// import './i18n';

const Services = () => {

    const { t, i18n } = useTranslation();
    const changeLanguage = (lng) => { i18n.changeLanguage(lng); }


    return (
        <div className="service">
            <h1 className="text-center text-uppercase">{t('my services')}</h1>
            
            {/*4 items  */}
            {/* <div class="services d-flex justify-content-center my-5"> */}
            <div class="services">

                <div className="items-services shadow">
                {/* <div className="bg-muted mx-5 py-3  border-5 text-center h2"> */}
                    <AiOutlineAntDesign className="icon border border-dark rounded-circle bg-warning text-center"/><br/>
                    <h5 className="text-center text-uppercase">{t('web design')}</h5>
                    <small className="explained-text">{t('web design text')}
                        {/* I approach each project
                        individually and focus on
                        modern design methods and quality. */}
                    </small>
                </div>


                <div className="items-services shadow">
                    <VscCode className="icon border border-dark rounded-circle bg-warning text-center"/><br/>
                    <h5 className="text-center text-uppercase">{t('development')}</h5>
                    <small className="explained-text">{t('development text')}
                         {/* I use modern proven technologies
                         for building <strong>web</strong> application
                         which is installable on <strong>IOS</strong> and <strong>Android</strong> devices. */}
                    </small>
                </div>
             
                <div className="items-services shadow">
                    <AiOutlineCloudServer className="icon border border-dark rounded-circle bg-warning text-center"/><br/>
                    <h5 className="text-center text-uppercase">{t('cloud')}</h5>
                    <small className="explained-text">{t('cloud text')}
                        {/* I approach each 
                        project individually
                        and focus on customer
                        satisfaction. */}
                    </small>
                </div>

                <div className="items-services shdow">
                    <AiOutlineCloudServer className="icon border border-dark rounded-circle bg-warning text-center"/><br/>
                    <h5 className="text-center text-uppercase">{t('network')}</h5>
                    <small className="explained-text">{t('network text')}
                        {/* Routing and Switching prortocols,
                        trouble-shooting,configuration and installation
                        of network devices. */}
                    </small>

                </div>
            </div>
        
        </div>
    )
}

export default Services
